<h1 class="areaHeading pt-5 pb-2 mt-5">Experience</h1>
<div class="timeline">
  <div *ngFor="let item of timelineData; index as idx">
    <div class="timeline-container" [ngClass]="{'left': idx%2 === 0, 'right': idx%2 !== 0}">
      <div [ngClass]="{'content-left': idx%2 === 0, 'content-right': idx%2 !== 0}">
        <div class="exp_container">
          <div class="logo">
            <img [src]="item.logoUrl" alt="logo">
          </div>
          <div class="content">
            <h2 class="txt-primary duration"> {{ item.duration }} </h2>
            <p class="txt-words title">
              {{ item.title }}
            </p>
            <a class="read-more" (click)="displayDetails(item.id)">
              Read more<mat-icon>double_arrow</mat-icon>
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 workex" *ngIf="item?.footer?.lname">
            <i class="fas" [ngClass]="item?.footer?.licon"></i>
            <span class="txt-words">
              {{item?.footer?.lname}}
            </span>
            <span class="txt-primary-orange">
              {{item?.footer?.lvalue}}
            </span>
          </div>
          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 certificate" *ngIf="item?.footer?.rname">
            <i class="fas" [ngClass]="item?.footer?.ricon"></i>
            <span class="txt-words">
              {{item?.footer?.rname}}
            </span>
            <span class="txt-primary-orange">
              {{item?.footer?.rvalue}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
